import gql from 'graphql-tag'

export const MY_WEB_NOTIFICATION_LIST = gql`
  query ($take: Int!, $skip: Int!, $important: Boolean!) {
    myWebNotificationList (pagination: { take: $take, skip: $skip },important: $important) {
      hasMore
      items {
        id
        title
        body
        imageUrl
        showFromDate
      }
    }
  }
`
export const MY_WEB_NOTIFICATION_LIST_URGENT = gql`
  query ($take: Int!, $skip: Int!, $important: Boolean!) {
    myWebNotificationList (pagination: { take: $take skip: $skip }  important: $important) {
      items {
        title # Subject 件名
        body # Text 本文
      }
    }
  }
`

export const GET_MY_WEB_NOTIFICATION = gql`
  query getMyWebNotification($id: Int!) {
    getMyWebNotification (id: $id) {
      id
      title
      body
      imageUrl
      showFromDate
    }
  }
`
